import { OrderedListOutlined, UnorderedListOutlined } from '@ant-design/icons';
import cx from 'classnames';
import { Button } from '@ui/components';
import { getIconStyles } from '../../utils';
import { useLists } from './hooks';

const iconStyles = getIconStyles();

type ListsProps = {
  disabled: boolean;
};

export const Lists = ({ disabled }: ListsProps) => {
  const { isOrderedList, isUnorderedList, formatOrderedList, formatUnorderedList } = useLists();

  return (
    <div className="flex items-center gap-1">
      <Button
        type="text"
        disabled={disabled}
        className={cx('p-2 rounded-md', isUnorderedList && 'bg-blue-300')}
        onClick={formatUnorderedList}
      >
        <UnorderedListOutlined style={iconStyles} />
      </Button>

      <Button
        type="text"
        disabled={disabled}
        className={cx('p-2 rounded-md', isOrderedList && 'bg-blue-300')}
        onClick={formatOrderedList}
      >
        <OrderedListOutlined style={iconStyles} />
      </Button>
    </div>
  );
};
